import { computePosition, flip, shift, offset, arrow } from "@floating-ui/dom";

export function update(trigger: Element, tooltip: HTMLElement, direction: "top" | "right" | "bottom" | "left" | null) {
    const arrowElement = document.createElement("div");
    arrowElement.className = "arrow";
    arrowElement.style.position = "absolute";
    arrowElement.style.width = "8px";
    arrowElement.style.height = "8px";
    arrowElement.style.background = "inherit";
    arrowElement.style.transform = "rotate(45deg)";

    const existingArrowElement = tooltip.querySelector(".arrow");
    if (existingArrowElement) {
        tooltip.replaceChild(arrowElement, existingArrowElement);
    } else {
        tooltip.appendChild(arrowElement);
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    computePosition(trigger, tooltip, {
        placement: direction ?? "top",
        middleware: [offset(8), flip(), shift({ padding: 16 }), arrow({ element: arrowElement })]
    }).then(({ x, y, placement, middlewareData }) => {
        Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`
        });

        const arrowData = middlewareData.arrow;
        if (!arrowData) return;

        const { x: arrowX, y: arrowY } = arrowData;

        const staticSideMap: Record<"top" | "right" | "bottom" | "left", "bottom" | "left" | "top" | "right"> = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        };

        const basePlacement = placement.split("-")[0] as "top" | "right" | "bottom" | "left";
        const staticSide = staticSideMap[basePlacement];

        Object.assign(arrowElement.style, {
            left: arrowX != null ? `${arrowX}px` : "",
            top: arrowY != null ? `${arrowY}px` : "",
            right: "",
            bottom: "",
            [staticSide as string]: "-4px"
        });
    });
}

export function showTooltip(trigger: Element, tooltip: HTMLElement) {
    tooltip.classList.add("show-tooltip");
    const tooltipDirection = trigger.getAttribute("data-tooltip-direction");
    update(trigger, tooltip, tooltipDirection as "top" | "right" | "bottom" | "left" | null);
}

export function hideTooltip(tooltip: HTMLElement) {
    tooltip.classList.remove("show-tooltip");
}

document.querySelectorAll("[data-tooltip]").forEach((trigger) => {
    const tooltipAttr = trigger.getAttribute("data-tooltip");
    let tooltip: HTMLElement | null = null;

    if (tooltipAttr) {
        if (tooltipAttr.startsWith("#")) {
            tooltip = document.getElementById(tooltipAttr.slice(1)) as HTMLElement;
        } else {
            tooltip = document.createElement("div");
            tooltip.setAttribute("role", "tooltip");
            tooltip.textContent = tooltipAttr;
            document.body.appendChild(tooltip);
        }
    }
    if (tooltip && trigger) {
        const events: [string, EventListener][] = [
            ["mouseenter", () => showTooltip(trigger, tooltip)],
            ["mouseleave", () => hideTooltip(tooltip)],
            ["focus", () => showTooltip(trigger, tooltip)],
            ["blur", () => hideTooltip(tooltip)]
        ];

        events.forEach(([event, listener]) => {
            trigger.addEventListener(event, listener);
        });
    }
});
